// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"22a80353","633":"8f7943a7","717":"5ade89d6","721":"7479597c","948":"4a01c651","985":"2b799594"}[chunkId] + ".chunk.js";
};